import { render, staticRenderFns } from "./BusinessNameDataUpdateEscalationFile.vue?vue&type=template&id=659c41ad&scoped=true&"
import script from "./BusinessNameDataUpdateEscalationFile.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateEscalationFile.vue?vue&type=style&index=0&id=659c41ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659c41ad",
  null
  
)

export default component.exports